<template>
    <!--描述：商品规格管理-->
    <div class="diy-container">
        <!--规格-->
        <div class="spec">
            <Spec @getSpecDetails="getSpecDetails"/>
        </div>

        <!--规格明细-->
        <div class="spec-details">
            <SpecDetails ref="SpecDetails" />
        </div>
    </div>
</template>

<script>
    import Spec from './Spec.vue';
    import SpecDetails from './SpecDetails.vue';

    export default {
        components: {
            Spec,
            SpecDetails
        },
        methods: {
            // 根据规格id 获取规格值列表
            getSpecDetails(spec_id) {
                this.$refs.SpecDetails.getSpecValue(spec_id);
            }
        }
    };
</script>

<style scoped>
    .diy-container{
        display: flex;
    }
    .spec {
        width: 375px;
        margin: 0 30px;
        border: 1px solid #CCCCCC;
        overflow: hidden;
    }
    .spec-details {
        flex: 1;
        border: 1px solid #CCCCCC;
        height: calc(100vh - 150px);
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/product/spec/index.vue